import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HamburgerIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 15) / 21}
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.05 2.14286H14.7C14.9785 2.14286 15.2455 2.02997 15.4425 1.82904C15.6394 1.62811 15.75 1.35559 15.75 1.07143C15.75 0.787268 15.6394 0.514746 15.4425 0.313814C15.2455 0.112883 14.9785 0 14.7 0H1.05C0.771524 0 0.504452 0.112883 0.307537 0.313814C0.110624 0.514746 0 0.787268 0 1.07143C0 1.35559 0.110624 1.62811 0.307537 1.82904C0.504452 2.02997 0.771524 2.14286 1.05 2.14286ZM0 7.5C0 7.21584 0.110624 6.94332 0.307537 6.74239C0.504452 6.54145 0.771524 6.42857 1.05 6.42857H19.95C20.2285 6.42857 20.4955 6.54145 20.6925 6.74239C20.8894 6.94332 21 7.21584 21 7.5C21 7.78416 20.8894 8.05668 20.6925 8.25761C20.4955 8.45855 20.2285 8.57143 19.95 8.57143H1.05C0.771524 8.57143 0.504452 8.45855 0.307537 8.25761C0.110624 8.05668 0 7.78416 0 7.5ZM0 13.9286C0 13.6444 0.110624 13.3719 0.307537 13.171C0.504452 12.97 0.771524 12.8571 1.05 12.8571H10.5C10.7785 12.8571 11.0455 12.97 11.2425 13.171C11.4394 13.3719 11.55 13.6444 11.55 13.9286C11.55 14.2127 11.4394 14.4853 11.2425 14.6862C11.0455 14.8871 10.7785 15 10.5 15H1.05C0.771524 15 0.504452 14.8871 0.307537 14.6862C0.110624 14.4853 0 14.2127 0 13.9286Z"
        fill="currentColor"
      />
    </svg>
  )
})

HamburgerIcon.displayName = 'HamburgerIcon'
